var React = require('react');

function GraphLines (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 0C9 0 0 9 0 20C0 31 9 40 20 40C31 40 40 31 40 20C40 9 31 0 20 0ZM4 20C4 11.2 11.2 4 20 4C24.3 4 28.1 5.7 31 8.4L23.2 21.3L14.7 14.6L6.2 28C4.8 25.6 4 22.9 4 20ZM20 36C15.6 36 11.7 34.2 8.8 31.4L15.7 20.5L24.3 27.3L33.7 11.8C35.1 14.2 36 17 36 20C36 28.8 28.8 36 20 36Z"}));
}

GraphLines.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"currentColor"};

module.exports = GraphLines;

GraphLines.default = GraphLines;
